export default () => {
  function initImpactAnimation() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {

          const items = document.querySelectorAll('.impact__wrapper-list .impact__item');
          const allLines = document.querySelectorAll('.line-number');

          items.forEach((item, index) => {
            setTimeout(() => {
              item.classList.add('show');

              if (index === items.length - 1) {
                setTimeout(() => {
                  allLines.forEach((line, lineIndex) => {
                    setTimeout(() => {
                      line.classList.add('animate');

                      setTimeout(() => {
                        line.classList.add('dots-show');
                      }, 800);
                    }, lineIndex * 200);
                  });
                }, 200);
              }
            }, index * 300);
          });

          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.3
    });

    const impactSection = document.querySelector('.impact');
    if (impactSection) {
      observer.observe(impactSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImpactAnimation);
  } else {
    initImpactAnimation();
  }
};
